





























































































































































































import { Vue, Component, Prop, Mixins, Watch } from "vue-property-decorator";
import CreateRole from "@/components/Auth/CreateRole.vue";
import { authMixin } from "../../auth/mixins";
import { AtomSpinner } from "epic-spinners";
import loader from "@/components/loader/nipigeloader.vue";
import { computed } from "vue";
@Component({
    components: {
        CreateRole,
        loader,
        AtomSpinner,
    },
})
export default class Role extends Mixins(authMixin) {
    data() {
        return {
            sortBy: "createdAt",
            sortDesc: true,
            loading: false,
        };
    }
    @Prop(Object) auth: any;
    private header: string = "Create a Role";
    private roles: any[] = [];
    private filteredList: any[] = [];
    private role: any = {};
    private roleModal: boolean = false;
    private roleColumns: any[] = [
        {
            key: "name",
            sortable: true,
        },
        {
            key: "description",
        },
        {
            key: "action",
        },
    ];
    loading = true;
    perPage = 10;
    hover = true;
    striped = false;
    filter = "";
    bordered = true;
    small = false;
    fixed = false;
    dark = false;
    currentPage = 1;

    private permissionMap: any = {};
    private allPermissions: any[] = [];
    @Watch("filter")
    onChange(newVal: string) {
        const list = this.$store.getters["role/GetRoleList"] || [];

        if (!newVal) {
            this.filteredList = list;
            return;
        }

        const search = newVal.toLowerCase();

        this.filteredList = list.filter((el) =>
            (el.name + " " + el.description).toLowerCase().includes(search),
        );
         
    }

    private insertRole(payload) {
        this.$store
            .dispatch("role/createRole", payload)
            .then((result) => {
                this.roles.push(result.response);
                this.$toasted.success("Successfully new role created");
            })
            .catch(() => this.$toasted.error("Name already exist"));
    }

    private async handleEdit() {
        const { _id, name, description } = this.role;
        const payload = {
            _id,
            data: {
                name,
                description,
            },
        };
        this.$store
            .dispatch("role/updateRole", payload)
            .then(() => {
                const index = this.roles.findIndex(r => r._id === _id);
            if (index !== -1) {
                this.$set(this.roles, index, JSON.parse(JSON.stringify(this.role)));
            }
            const index2 = this.filteredList.findIndex(item => item._id === _id);
            if (index2 !== -1) {
                this.$set(this.filteredList, index2, JSON.parse(JSON.stringify(this.role)));
            }
                this.$swal({
                    title: "Success",
                    text: "Role edited successfully!!",
                    type: "success",
                });
                this.clearModal();
            })
            .catch(() => this.clearModal());
    }

    private async deleteRole({ item }) {
        await this.$swal({
            title: "Are you sure?",
            text: "You can't revert this action!!",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.$store
                    .dispatch("role/deleteRole", item._id)
                    .then((res: any) => {
                        this.roles.filter((e, i) =>
                            item._id === e._id ? this.roles.splice(i, 1) : null,
                        );
                        this.$toasted.success("Deleted!");
                    });
            }
        });
    }

    private clearModal() {
        this.role = {};
        this.roleModal = false;
    }

    private editRole(row) {
        this.role = JSON.parse(JSON.stringify(row.item));
        this.header = "Edit a Role";
        this.roleModal = true;
    }

    private async expandRole(row) {
        this.$router.push({
            name: "RolePermission",
            query: {
                role: row.item._id,
            },
        });
        // let opening = !row.detailsShowing;
        // row.toggleDetails();
        // if(!opening){ return; }
        // const { item } = row;
        // const { permissions } = await getPermissionsByRole(item._id);
        // this.permissionMap[item._id] = permissions || [];
    }

    private async addPermissionToRole(selectedOption, id, row) {
        const role = row.item._id;
        Object.assign(this.permissionMap, {
            [role]: this.permissionMap[role].concat([selectedOption]),
        });
    }

    public async mounted() {
        this.loading = true;
        await this.$store
            .dispatch("role/fetchRoles")
            .catch((error) => console.log(error));

        await this.$store
            .dispatch("permission/fetchAllPermission")
            .catch((error) => console.log(error));
        this.roles = this.$store.getters["role/GetRoleList"] || [];
        this.filteredList =[... this.roles];
        this.loading = false;

        this.allPermissions =
            this.$store.getters["permission/GetAllPermissionList"];
        this.loading = false;
    }
}
